// this could be refactored a little to share more from AS

import React from "react";
import { func, object } from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import debounce from "lodash/debounce";
import axios from "axios";
import {
  reduxForm,
  Field,
  getFormValues,
  change,
  initialize,
  destroy,
} from "redux-form";
import { getWidth } from "redux-window";
import { Input, Select, Multiselect, Toggle } from "Components/Form";
import Results from "Components/Search/Results";
import Loading from "Components/Loading";
import Location from "Components/Search/Location";
import SearchWidgets from "Components/Search/Widgets";
import search from "./search";
import AdvancedSearchButton from "./AdvancedSearchButton";
import BecomeALicensedVenue from "./BecomeALicensedVenue";
import { FaUsers, FaBed, FaTimes, FaFilter } from "react-icons/fa";
import {
  isLoggedIn,
  isAgency,
  isAgencyApproved,
  token, isRolePlatformAdmin, isCorporate, isVenue,
} from "../../modules/auth";
import { hasActiveCorporateAccount, hasCorporateAccess, hasLicensedVenues, isCompanyUser } from "../../modules/permissions";
import qs from "query-string";
import { fetchAgencies, fetchCompanies, storeLastSimpleSearch } from "../../redux/actions";
import { checkVenueForPreferredProgramme } from "../../services/hotelGroupService/preferredProgrammesService";
import { checkVenuesForCommercialDeals } from "../../services/commercialDealService/commercialDeals";
import HotelGroup from "../../Components/Search/HotelGroup";
import MultiSelect from "../../ui/MultiSelect";
import FindDestinationOrVenueAgency from "./FindDestinationOrVenueAgency";
import FindDestinationOrVenueCompany   from "./FindDestinationOrVenueCompany";
const form = "simple-search";
const defaultState = {
  results: [],
  isInProgramme: [],
  hasCommercialDeal: [],
  count: 0,
  loading: false,
  error: null,
  selectedAgency: null,
  selectedCompanyAsObj: null,
  selectedAgencyAsObj: null,
  selectedCompany: null,
  companies: null
};
const startRadiusInMiles = 20;

class SearchForm extends React.Component {
  static propTypes = {
    destroy: func.isRequired,
    change: func.isRequired,
    values: object.isRequired,
  };

  state = {
    categories: [],
    results: [],
    loading: false,
    error: undefined,
    count: 0,
    filtersVisible: false,
    uuid: null,
    agencies: null,
    selectedAgency: null,
    selectedAgencyAsObj: null,
    companies: null,
    selectedCompany: null,
    selectedCompanyAsObj: null,
  };

  componentDidMount() {
    const { location, dispatch } = this.props;
    const queryParams = new URLSearchParams(location.search);
    if(localStorage.getItem('savedResultsSort')) {
      dispatch(change('simple-search', 'sortBy', localStorage.getItem('savedResultsSort')))
    }

    let queryParamsObject = {};
    for (let [key, value] of queryParams.entries()) {
      if (queryParamsObject[key]) {
        queryParamsObject[key] = [].concat(queryParamsObject[key], value);
      } else {
        queryParamsObject[key] = value;
      }
    }
    const { formValues } = this.props;
    const initialValues = {
      ...formValues,
      ...queryParamsObject,
      radius: formValues?.radius || 1609.344 * startRadiusInMiles,
    };
    // Update the form with the new values
    Object.keys(initialValues).forEach(key => {
      if (key !== "results") {
        dispatch(change("simple-search", key, initialValues[key]));
      }
    });
    if(queryParamsObject.agency) {
      checkVenueForPreferredProgramme(this.props.token, queryParamsObject.agency,  queryParamsObject.company ?queryParamsObject.company : null ).then(response => {
        this.setState({
          isInProgramme: response,
        });
        this.props.search(this.props.history, this.stateSetter, {sortBy: queryParamsObject.company ? 'Company Preferred Programme' : 'Agency Preferred Programme'});
      });
    }else{
      this.props.search(this.props.history, this.stateSetter);
    }


    this.setState({ uuid: crypto.randomUUID() });
    axios
      .get(`${window.API}/venue-categories`)
      .then(r => {
        this.setState({
          categories: r.data.map(item => ({
            label: item.name,
            value: item.id,
          })),
        });
      })
      .catch(() => {});

    if (this.props.isAgency || this.props.isRolePlatformAdmin) {
      this.props.fetchAgencies(this.props.token, 1, { visibleOnly: true }, true).then(response => {
       this.setState({
         agencies: response.data.data
       })
        if(queryParamsObject.agency && queryParamsObject.agency !== 'false') {
          let agency = response.data.data.find(function (agency) {
            return parseInt(agency.id) === parseInt(queryParamsObject.agency)
          })
          if(agency) {
            let company = null;
            if(queryParamsObject.company && queryParamsObject.company !== 'false') {
              company = agency.companies.find(function (company) {
                return parseInt(company.id) === parseInt(queryParamsObject.company)
              })
            }
            this.setState({
              companies: agency.companies,
              selectedAgency: queryParamsObject.agency,
              selectedAgencyAsObj: {
                text: agency.name,
                value: agency.id,
                label: agency.name,
              },
              selectedCompany: company ? queryParamsObject.company : null,
              selectedCompanyAsObj: company ? {
                text: company.name,
                value: company.id,
                label: company.name,
                isCorporate: company.isCorporate
              } : null
            })
            dispatch(change('simple-search', 'agency',  queryParamsObject.agency))

            if(company && company.isCorporate) {
              dispatch(change('simple-search', 'sortBy', "Company Preferred Programme"))
            }
            if(queryParamsObject.agency && (!queryParamsObject.company || !company || !company.isCorporate) ) {
              dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
            }
          }
          if(!this.state.isInProgramme) {
            checkVenueForPreferredProgramme(this.props.token, queryParamsObject.agency,  queryParamsObject.company).then(response => {
              this.setState({
                isInProgramme: response,
              });
            });
          }

        }
        if(response.data.data.length === 1){
          let agency = response.data.data.find(x=>x!==undefined)
          let company = null;

          this.setState({
            companies:  agency.companies,
            selectedAgency: agency.id
          })
          if(queryParamsObject.company){
            company = agency.companies.find(function (company) {
              return parseInt(company.id) === parseInt(queryParamsObject.company)
            })
            if(company) {
              this.setState({
                selectedCompany: company ? queryParamsObject.company : null,
                selectedCompanyAsObj: company ? {
                  text: company.name,
                  value: company.id,
                  label: company.name,
                  isCorporate: company.isCorporate
                } : null
              })
              if(company.isCorporate) {
                dispatch(change('simple-search', 'sortBy', "Company Preferred Programme"))
              }else{
                dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
              }
            }

            if(queryParamsObject.agency && (!queryParamsObject.company || !company || !company.isCorporate) ) {
              dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
            }
          }else{
            dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
          }
          dispatch(change('simple-search', 'agency',  agency.id))
          checkVenueForPreferredProgramme(this.props.token, agency.id,  queryParamsObject.company).then(response => {
            this.setState({
              isInProgramme: response,
            });
          });
        }
      });
    }

    if(queryParamsObject.company) {
      this.setState({
        selectedCompany: queryParamsObject.company
      })
      dispatch(change('simple-search', 'company',  queryParamsObject.company))
    }
    if(!this.state.isInProgramme && this.props.isCorporate) {
      checkVenueForPreferredProgramme(this.props.token, queryParamsObject.agency,  queryParamsObject.company).then(response => {
        this.setState({
          isInProgramme: response,
        });
        this.props.search(this.props.history, this.stateSetter, {sortBy: "Company Preferred Programme"});
      });

    }


  }

  reset = () => {
    this.props.destroy(form);
    this.setState({
      ...defaultState,
    });
  };

  sortForPP = (results, isInProgramme, v = false) => {
    let sortBy = v || this.props.values.sortBy;
    let agencyResults = [];
    let companyResults = [];
    let nonResults = [];
    results.map(function(a) {
      let isInProgrammeCompanyA = isInProgramme &&
        isInProgramme.company &&
        typeof isInProgramme.company.find(company => company === a.id) !==
        "undefined";

      let isInProgrammeAgencyA = isInProgramme &&
        isInProgramme.agency &&
        typeof isInProgramme.agency.find(company => company === a.id) !==
        "undefined";

      if(sortBy === 'Agency Preferred Programme') {
        if(isInProgrammeAgencyA || (isInProgrammeAgencyA &&  isInProgrammeCompanyA) ) {
          agencyResults.push(a);
        }
        if(!isInProgrammeAgencyA &&  isInProgrammeCompanyA ) {
          companyResults.push(a);
        }
        if(!isInProgrammeAgencyA && !isInProgrammeCompanyA) {
          nonResults.push(a)
        }
      }
      if(sortBy === 'Company Preferred Programme') {
        if(isInProgrammeCompanyA || (isInProgrammeAgencyA &&  isInProgrammeCompanyA) ) {
          companyResults.push(a);
        }
        if(isInProgrammeAgencyA &&  !isInProgrammeCompanyA ) {
          agencyResults.push(a);
        }
        if(!isInProgrammeAgencyA && !isInProgrammeCompanyA) {
          nonResults.push(a)
        }
      }

    });

    let orderedResults = [];
    if(sortBy === 'Agency Preferred Programme') {
      orderedResults = orderedResults.concat(agencyResults);
      orderedResults = orderedResults.concat(companyResults);
      orderedResults = orderedResults.concat(nonResults)
    }else if(sortBy === 'Company Preferred Programme'){
      orderedResults = orderedResults.concat(companyResults);
      orderedResults = orderedResults.concat(agencyResults);
      orderedResults = orderedResults.concat(nonResults)
    }else{
      orderedResults = results;
    }
    this.setState({loading: false})
    return orderedResults
  }

  stateSetter = {
    loading: () => this.setState({ loading: true, results: [] }),
    error: (
      error = "Sorry, there was an error when searching. Please check the fields and try again."
    ) => this.setState({ loading: false, error }),
    clear: () => this.setState({ ...defaultState }),
    results: (results, count, prefProgramme, v) => {
      checkVenuesForCommercialDeals(results.map(r => r.id), this.props.token).then(response => {
        this.setState({
          hasCommercialDeal: response,
        });
      });
      if (prefProgramme && this.state.isInProgramme) {
        let isInProgramme = this.state.isInProgramme;
        let orderedResults = results;
        if(this.state.selectedCompany) {
           orderedResults = results.sort(function(a, b) {
            return (
              (
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === b.id
                  ) !== "undefined")) -
              (
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === a.id
                  ) !== "undefined"))
            );
          });
        }else{
           orderedResults = results.sort(function(a, b) {
            return (
              ((isInProgramme &&
                  isInProgramme.agency &&
                  typeof isInProgramme.agency.find(company => company === b.id) !==
                  "undefined") ||
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === b.id
                  ) !== "undefined")) -
              ((isInProgramme &&
                  isInProgramme.agency &&
                  typeof isInProgramme.agency.find(company => company === a.id) !==
                  "undefined") ||
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === a.id
                  ) !== "undefined"))
            );
          });
        }
        this.setState({
          results: orderedResults,
          count,
          loading: false,
          error: false,
        });
      } else {
        if(v && typeof v.sortBy !== "undefined") {
          let ordered = this.sortForPP(results, this.state.isInProgramme, v.sortBy);
          this.setState({
            results: ordered,
            count,
            loading: false,
            error: false,
          });
        }else{
          this.setState({
            results,
            count,
            loading: false,
            error: false,
          });
        }
      }
    },
  };

  searchOnBlur = () => {
    this.props.search(this.props.history, this.stateSetter);
  };

  searchOnChange = debounce((e, v, pv, name) => {
    if(name === 'sortBy') {
      localStorage.setItem('savedResultsSort', v);
    }
    if (v === "Agency Preferred Programme" || v === "Company Preferred Programme") {
      let results = [...this.state.results];
      this.props.search(this.props.history, this.stateSetter, {
        commission: name === "agencyRates" ? v : 0,
        sortBy: v,
        [name]:
          name === "venueCategoryId" && v !== null
            ? v.map(option => option.value)
            : v,
      });
    } else {
      this.props.search(this.props.history, this.stateSetter, {
        commission: name === "agencyRates" ? v : 0,
        sortBy: this.props.values.sortBy,
        [name]:
          name === "venueCategoryId" && v !== null
            ? v.map(option => option.value)
            : v,
      });
    }
  }, 500);

  groupOnChange = debounce((e, v, pv, name) => {

    if (v === "Agency Preferred Programme" || v === "Company Preferred Programme") {
      let results = [...this.state.results];
      let orderedResults = this.sortForPP(results, this.state.isInProgramme, v)
      this.setState({
        results: orderedResults,
      });
    } else {
      this.props.search(this.props.history, this.stateSetter, {
        commission: name === "agencyRates" ? v : 0,
        [name]:
          name === "venueCategoryId" && v !== null
            ? v.map(option => option.value)
            : v,
      });
    }
  }, 500);

  submit = () => {
    // nowt
  };

  resultsHasDestinations = () => {
    const { results } = this.state;
    return !!results && results.some(result => result.destination_city);
  };

  sortByOptions() {
    return [
      {
        text: "Sort by Default",
        value: "ContentUpdate",
      },
      {
        text: "Sort by Distance",
        value: "Distance",
      },
      {
        text: "Sort by Capacity",
        value: "Capacity",
      },
      this.resultsHasDestinations()
        ? { text: "Sort by Destination", value: "Destination" }
        : null,
      {
        text: "Sort by Bedrooms",
        value: "Bedrooms",
      },
      {
        text: "Sort by Meeting Rooms",
        value: "Meeting rooms",
      },
      {
        text: "Sort by Nearest Airport",
        value: "Nearest airport",
      },
      (!this.props.isCompanyUser ) && this.state.isInProgramme && this.state.isInProgramme.agency.length > 0 ?
      {
        text: "Sort by Agency Preferred Programmes",
        value: "Agency Preferred Programme",
      } : null,
      (!this.state.selectedCompanyAsObj || this.state.selectedCompanyAsObj.isCorporate) && (!this.props.isCompanyUser || (this.props.isCompanyUser && this.props.isCorporate)) && (this.state.isInProgramme && this.state.isInProgramme.company.length > 0) ? {
        text: "Sort by Company Preferred Programmes",
        value: "Company Preferred Programme",
      } : null,
    ].filter(Boolean);
  }

  toggleFiltersVisible = () => {
    this.setState({ filtersVisible: !this.state.filtersVisible });
  };

  getNoResultsMessage = () => {
    const { location, name } = qs.parse(this.props.location.search);
    let loading = this.state.loading;
    if (!location || loading || !this.props.values.location) {
      return "";
    }

    return `No results found for ${location ? "location " + location : ""}${
      location && name ? " and for" : ""
    }${name ? " name " + name : ""}`;
  };

  getAgencyOptions = () => {
    if(this.state.agencies) {
      return this.state.agencies.map(function (agency) {
        return {
          text: agency.name,
          value: agency.id,
          label: agency.name,
        }
      })
    }else {
      return []
    }
  }

  getCompanyOptions = () => {
    if(this.state.companies) {

      return this.state.companies.map(function (company) {
        return {
          text: company.name,
          value: company.id,
          label: company.name,
          isCorporate: company.isCorporate
        }
      })
    }else {
      return []
    }
  }

  agencyOnChange = (e) => {
    const { location, dispatch } = this.props;
    let agency = this.state.agencies.find(function (agency) {
      return parseInt(agency.id) === parseInt(e.value)
    })
    this.setState({
      selectedAgency: e.value,
      companies: agency.companies,
      selectedAgencyAsObj: e,
      selectedCompany: null,
      selectedCompanyAsObj: null
    })
    dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
    dispatch(change('simple-search', 'agency',  e.value))
    localStorage.setItem('savedResultsSort',  "Agency Preferred Programme");
    checkVenueForPreferredProgramme(this.props.token, e.value,null).then(response => {
      let orderedResults = this.sortForPP(this.state.results, this.state.isInProgramme, "Agency Preferred Programme")
      this.setState({
        isInProgramme: response,
        results: orderedResults,
      });
    });


  }

  companyOnChange = debounce((e, v, pv, name) => {
    const { location, dispatch } = this.props;
    let company = this.state.companies.find((company) => parseInt(company.id) === parseInt(e.value));
    if(company && company.isCorporate){
      this.setState({
        selectedCompany: e.value,
        results: [],
        selectedCompanyAsObj: e
      })
      dispatch(change('simple-search', 'sortBy', "Company Preferred Programme"))
      dispatch(change('simple-search', 'company',  e.value))
      localStorage.setItem('savedResultsSort',  "Company Preferred Programme");
      checkVenueForPreferredProgramme(this.props.token, this.state.selectedAgency, e.value).then(response => {
        this.setState({
          isInProgramme: response,
        });
        this.props.search(this.props.history, this.stateSetter, {
          commission: name === "agencyRates" ? v : 0,
          sortBy: "Company Preferred Programme",
          [name]:
            name === "venueCategoryId" && v !== null
              ? v.map(option => option.value)
              : v,
        });
      });
    }else{
      this.setState({
        selectedCompany: e.value,
        selectedCompanyAsObj: e
      })
      dispatch(change('simple-search', 'company',  e.value))
      dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
      localStorage.setItem('savedResultsSort',  "Agency Preferred Programme");
      checkVenueForPreferredProgramme(this.props.token, this.state.selectedAgency, e.value).then(response => {
        let orderedResults = this.sortForPP(this.state.results, this.state.isInProgramme, "Agency Preferred Programme")
        this.setState({
          isInProgramme: response,
          results: orderedResults,
        });
      });
      this.props.search(this.props.history, this.stateSetter, {
        commission: name === "agencyRates" ? v : 0,
        sortBy: "Agency Preferred Programme",
        [name]:
          name === "venueCategoryId" && v !== null
            ? v.map(option => option.value)
            : v,
      });
    }
  })

  render() {
    return (
      <>
        <form
          onSubmit={this.props.handleSubmit(this.submit)}
          autoComplete="off"
          className="sticky z-10"
          style={{ top: this.props.stickyOffset }}
        >
          <div
            className="container py-8 flex justify-center items-center bg-cover bg-center bg-no-repeat shadow"
            style={{ backgroundImage: "url('/img/search-bg.jpg')" }}
          >
            <div
              style={{ backgroundColor: "rgba(0,0,0,.6)" }}
              className="p-5 relative w-full md:w-2/3 lg:w-2/3"
            >
              <div className="row">
                <div className="w-full flex flex-wrap relative">
                  <div className="flex flex-col col col-w-full xl:col-w-1/3">
                    <p className="text-white uppercase font-normal mb-1 text-xs">
                      Where is your event?
                    </p>
                    <Location
                      id="location-search"
                      formId={form}
                      icon="/img/map-marker.svg"
                      label="Where is your event?"
                      labelClassName="sr-only"
                      name="location"
                      fieldClassName="w-full mb-0"
                      wrapperClassName=""
                      onPlaceFound={() => {
                        this.props.search(this.props.history, this.stateSetter);
                        this.props.storeLastSimpleSearch(this.props.values);
                      }}
                      placeholder="Search by place"
                    />
                  </div>
                  <div className="flex flex-col col col-w-full xl:col-w-1/3">
                    <p className="text-white uppercase font-normal mb-1 text-xs">
                      Search by Group or Brand
                    </p>
                    <HotelGroup
                      id="hotel-group-search"
                      formId={form}
                      fieldClassName="w-full mb-0"
                      wrapperClassName=""
                      placeholder="Search by group"
                      onGroupSelected={() => {
                        this.props.search(this.props.history, this.stateSetter);
                        this.props.storeLastSimpleSearch(this.props.values);
                      }}
                    />

                  </div>
                  {/* <div className="rounded-50 bg-edge-blue p-2 absolute-center hidden xl:block">
                    <span className="text-white font-normal text-xs">OR</span>
                  </div> */}
                  <div className="flex flex-col col col-w-full xl:col-w-1/3">
                    <p className="text-white uppercase font-normal mb-1 text-xs">
                      Search by name
                    </p>
                    <Field
                      id="venue-search"
                      label="Search by name"
                      name="name"
                      labelClassName="sr-only"
                      fieldClassName="w-full mb-0"
                      wrapperClassName=""
                      component={Input}
                      onChange={this.searchOnChange}
                      placeholder="Start typing the name"
                    />
                  </div>
                  {this.props.isSuperAgencyAndHasMultipleAgencies || this.props.isRolePlatformAdmin ?  <div className="flex flex-col col col-w-full xl:col-w-1/3 mb-2">
                    <p className="text-white uppercase font-normal mb-1 text-xs">
                      Which Agency?
                    </p>
                    <MultiSelect
                      id="agency-search"
                      options={this.getAgencyOptions()}
                      name="agency"
                      labelClassName="sr-only"
                      wrapperClassName=""
                      component={Select}
                      onChange={ e => this.agencyOnChange(e)}
                      placeholder="Select Agency"
                      value={this.state.selectedAgencyAsObj}
                    />
                  </div> : null }

                  {this.state.selectedAgency || (this.props.isLoggedIn && this.props.isAgency && !this.props.isSuperAgencyAndHasMultipleAgencies && !this.props.isRolePlatformAdmin) ?
                    <div className="flex flex-col col col-w-full xl:col-w-1/3 mb-2">
                      <p className="text-white uppercase font-normal mb-1 text-xs">
                       Search For Company
                      </p>
                      <MultiSelect
                        id="company-search"
                        options={this.getCompanyOptions()}
                        name="company"
                        labelClassName="sr-only"
                        wrapperClassName=""
                        component={Select}
                        onChange={ e => this.companyOnChange(e)}
                        placeholder="Select Company"
                        value={this.state.selectedCompanyAsObj}
                      />
                    </div> : null
                  }

                </div>
                <div className="col col-w-full justify-between flex">
                  <AdvancedSearchButton />
                  <div
                    className="pointer uppercase font-bold text-white self-end text-xs flex"
                    onClick={() => {
                      this.reset();
                    }}
                  >
                    Clear all
                    <FaTimes className="text-white ml-2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container w-full bg-white p-4 flex flex-wrap md:flex-no-wrap items-center justify-between sticky z-negative">
            <span className="font-normal text-base hidden lg:block">
              Refine your search
            </span>
            <div className="lg:mx-4 w-full lg:mb-4 block lg:hidden flex justify-between flex justify-center">
              <div
                className="flex items-center"
                onClick={this.toggleFiltersVisible}
              >
                <FaFilter className="mr-2 text-2xl" />
                <p className="uppercase font-bold m-0 pointer">
                  {this.state.filtersVisible ? "Close filters" : "Open filters"}
                </p>
              </div>
              <Field
                name="sortBy"
                wrapperClassName="w-48"
                noPlaceholder
                options={this.sortByOptions()}
                labelClassName="sr-only"
                label="Sort by"
                placeholder="Sort by..."
                selectClasses="uppercase"
                component={Select}
                onChange={this.searchOnChange}
              />
            </div>
            {(this.props.desktop || this.state.filtersVisible) && (
              <>
                <div className="px-4 w-1/3 md:px-3 md:w-1/6 mb-4 md:mb-0">
                  <p className="uppercase text-grey-md font-bold text-xs mb-1">
                    Max delegates
                  </p>
                  <div className="flex items-center">
                    <div>
                      <FaUsers className="mr-2 text-2xl hidden md:block" />
                    </div>
                    <Field
                      label="Max delegates"
                      name="capacity"
                      autoComplete="off"
                      labelClassName="sr-only"
                      wrapperClassName="flex"
                      component={Input}
                      onChange={this.searchOnChange}
                    />
                  </div>
                </div>
                <div className="px-4 w-1/3 md:px-3 md:w-1/6 mb-4 md:mb-0">
                  <p className="uppercase text-grey-md font-bold text-xs mb-1">
                    Bedrooms
                  </p>
                  <div className="flex items-center">
                    <div>
                      <FaBed className="mr-2 text-2xl hidden md:block" />
                    </div>
                    <Field
                      label="Bedrooms"
                      name="total_bedrooms"
                      labelClassName="sr-only"
                      wrapperClassName="flex"
                      autoComplete="off"
                      component={Input}
                      onChange={this.searchOnChange}
                    />
                  </div>
                </div>
                {/*<div className="px-4 w-1/3 md:px-3 md:w-1/6 mb-4 md:mb-0">*/}
                {/*  <p className="uppercase text-grey-md font-bold text-xs mb-1">*/}
                {/*    Star rating*/}
                {/*  </p>*/}
                {/*  <div className="flex items-center">*/}
                {/*    <FaStar className="mr-2 text-2xl hidden md:block" />*/}
                {/*    <Field*/}
                {/*      name="star_rating"*/}
                {/*      label="STAR RATING"*/}
                {/*      placeholder="Select"*/}
                {/*      labelClassName="sr-only"*/}
                {/*      wrapperClassName="flex justify-center w-full"*/}
                {/*      component={Select}*/}
                {/*      options={["3", "4", { value: "5", text: "5+" }]}*/}
                {/*      onChange={this.searchOnChange}*/}
                {/*    />*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className="mx-4 w-full md:w-1/6 mb-4 md:mb-0">
                  <p className="uppercase text-grey-md font-bold text-xs mb-1">
                    Venue type
                  </p>
                  <div className="flex items-center">
                    <Field
                      name="types"
                      label="Venue Type"
                      labelClassName="sr-only"
                      component={Multiselect}
                      placeholder="Select"
                      wrapperClassName="flex w-full"
                      options={this.state.categories}
                      onChange={this.searchOnChange}
                    />
                  </div>
                </div>
                {/*<div className="mx-4 w-full md:w-1/6">*/}
                {/*  <p className="uppercase text-grey-md font-bold text-xs mb-1">*/}
                {/*    Brand*/}
                {/*  </p>*/}
                {/*  <div className="flex items-center">*/}
                {/*    <Field*/}
                {/*      name="brand"*/}
                {/*      label="Brand"*/}
                {/*      labelClassName="sr-only"*/}
                {/*      component={Input}*/}
                {/*      fieldClassName="w-full mb-0"*/}
                {/*      wrapperClassName="flex w-full"*/}
                {/*      onChange={this.searchOnChange}*/}
                {/*    />*/}
                {/*  </div>*/}
                {/*</div>*/}
                {this.props.isAgency && this.props.isAgencyApproved && (
                  <div className="mx-4 w-full md:w-1/6">
                    <p className="uppercase text-grey-md font-bold text-xs mb-1">
                      Only agency offers
                    </p>
                    <div className="flex items-center">
                      <Field
                        name="agencyRates"
                        labelClassName="sr-only"
                        component={Toggle}
                        fieldClassName="w-full mb-0"
                        wrapperClassName="flex w-full"
                        onChange={this.searchOnChange}
                      />
                    </div>
                  </div>
                )}

              </>
            )}
          </div>
        </form>
        <div className="instantSearchResultsContainer container bg-grey py-5">
          <div className="row">
            <div className="col col-w-full lg:col-w-3/4">
              {this.state.loading ? <Loading large /> : null}
              {this.state.error ? (
                <p className="md:mt-8 text-warning">{this.state.error}</p>
              ) : null}
              {this.state.count ? (
                <div>
                  <div className="flex flex-wrap justify-between">
                    <h1>
                      Showing {this.state.count} venues in{" "}
                      {this.props.values.location}
                    </h1>
                    <Field
                      name="sortBy"
                      wrapperClassName="w-48 hidden md:block"
                      noPlaceholder
                      options={this.sortByOptions()}
                      labelClassName="sr-only"
                      label="Sort by"
                      placeholder="Sort by..."
                      selectClasses="uppercase"
                      component={Select}
                      onChange={this.searchOnChange}
                    />
                  </div>
                  {this.props.desktop && !this.props.isLoggedIn && this.props.isVenueUser && (
                    <BecomeALicensedVenue
                      headerText="Want to add your venue?"
                      mainMessage={
                        <span>
                          Add your venue for free by{" "}
                          <strong>registering online</strong>
                        </span>
                      }
                      linkToURL="/venues"
                      buttonText="Register Now"
                    />
                  )}
                  {this.props.desktop &&
                    this.props.isLoggedIn &&
                    !this.props.hasLicensedVenues && this.props.isVenueUser && <BecomeALicensedVenue />}
                  {this.props.desktop &&
                    this.props.isLoggedIn &&
                     this.props.isAgency && <FindDestinationOrVenueAgency />}
                  {this.props.desktop &&
                    this.props.isLoggedIn &&
                    this.props.isCompanyUser && <FindDestinationOrVenueCompany />}
                  <div>
                    <div className="w-full" id="results">
                      <Results
                        type="simple"
                        results={this.state.results}
                        loading={this.state.loading}
                        error={this.state.error}
                        uuid={this.state.uuid}
                        isInProgramme={this.state.isInProgramme}
                        hasCommercialDeal={this.state.hasCommercialDeal}
                        selectedCompany={this.state.selectedCompany}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <p className={"text-center font-bold text-xl"}>
                  {" "}
                  {this.getNoResultsMessage()}{" "}
                </p>
              )}
            </div>
            <div
              className="col col-w-full lg:col-w-1/4 fixed pin-b md:relative bg-white md:bg-transparent"
              style={!this.props.desktop ? { padding: 0 } : {}}
            >
              <div className="sticky" style={{ top: 180 }}>
                <SearchWidgets
                  results={this.state.results}
                  form="simple-search-shortlist"
                  searchForm="simple-search"
                  selectedCompany={this.state.selectedCompany}
                  search={() => {
                    this.props.search(this.props.history, this.stateSetter)
                    }
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  const queryParams = new URLSearchParams(props.location.search);

  let queryParamsObject = {};
  for (let [key, value] of queryParams.entries()) {
    if (queryParamsObject[key]) {
      queryParamsObject[key] = [].concat(queryParamsObject[key], value);
    } else {
      queryParamsObject[key] = value;
    }
  }
  let formValues = getFormValues(form)(state);
  let initialValues = {
    ...formValues,
    ...queryParamsObject,
  };
  if (!initialValues.hasOwnProperty("radius")) {
    initialValues.radius = 1609.344 * startRadiusInMiles;
  }
  return {
    values: initialValues || {},
    initialValues,
    radius: 1609.344 * startRadiusInMiles,
    desktop: getWidth(state) > 991,
    stickyOffset: getWidth(state) > 1199 ? -196 : -275,
    isAgency: isAgency(state),
    isVenueUser: isVenue(state),
    isAgencyApproved: isAgencyApproved(state),
    isSuperAgencyAndHasMultipleAgencies: state.auth.agency && state.auth?.agency?.is_super_agent  &&  state.auth.agency.child_agencies &&  state.auth.agency.child_agencies.length  > 0,
    isLoggedIn: isLoggedIn(state),
    hasLicensedVenues: hasLicensedVenues(state.auth),
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    isCompanyUser: isCompanyUser(state.auth),
    isCorporate: state.auth?.corporateAccount && hasCorporateAccess(state.auth),
  };
};

export default withRouter(
  reduxForm({
    form,
    destroyOnUnmount: false,
    enableReinitialize: true,
  })(
    connect(mapStateToProps, {
      search,
      change,
      initialize,
      destroy,
      storeLastSimpleSearch,
      fetchAgencies,
      fetchCompanies,
    })(SearchForm)
  )
);
